import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useInventoryContext } from '../contexts/InventoryContext';
import { formatARS } from '../utils/format';
import { inputClass } from './FormField';
interface VehicleSelectProps {
  id: string;
  value: string;
  onChange: (id: string) => void;
  placeholder: string;
  disabled?: boolean;
  excludeIds?: string[];
}
export function VehicleSelect({
  id,
  value,
  onChange,
  placeholder,
  disabled = false,
  excludeIds = []
}: VehicleSelectProps) {
  const {
    cars
  } = useInventoryContext();
  const options = [...cars].filter(car => !excludeIds.includes(car.id)).sort((a, b) => `${a.brand} ${a.model}`.localeCompare(`${b.brand} ${b.model}`, 'es'));
  return <div className="relative" data-id="element-421" data-mp="pcbcy7oxbtac">
      <select id={id} value={value} disabled={disabled} onChange={e => onChange(e.target.value)} className={`${inputClass} appearance-none pr-9 disabled:cursor-not-allowed disabled:opacity-50`} data-id="element-422" data-mp="pd30qwca4mq2">
        <option value="" data-id="element-423" data-mp="1w9mpi51jcg2f">{placeholder}</option>
        {options.map(car => <option key={car.id} value={car.id} data-id="element-424" data-mp="218qzuz074juc">
            {car.brand} {car.model} {car.version} {car.year} · {formatARS(car.cashPrice)}
          </option>)}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-425" data-mp="1nbkjfb2y2x8a" />
    </div>;
}